import { Contract, ContractType } from 'cpes-common';
import { useAnalyticsActionTracker } from '@cp-shared-19/frontend-ui';
import { Button, ButtonContainer, Callout, Modal } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { currentBrand } from '../../../config/config';

type CustomerHappinessIndexTypes = {
    handleButtonClick: () => void;
    contracts?: Contract[];
    redirectUrl?: string | null;
    isModalShown?: boolean;
    onModalClose?: () => void;
};

export const CustomerHappinessIndexUi: React.FC<CustomerHappinessIndexTypes> = ({
    handleButtonClick,
    contracts,
    redirectUrl,
    isModalShown,
    onModalClose,
}) => {
    const { t } = useTranslation('customer-happiness-index');
    const { onAction } = useAnalyticsActionTracker('chi');

    const onButtonClick = () => {
        onAction();
        handleButtonClick();
    };

    const handleModalConfirm = () => {
        if (redirectUrl) {
            window.open(redirectUrl, '_blank', 'noopener,noreferrer');
        }
        onModalClose?.();
    };

    if (contracts) {
        const isFinancing = contracts.every(item => item.contractType === ContractType.FINANCING);
        const isLeasing = contracts.every(item => item.contractType === ContractType.OPERATING_LEASE);
        const isFinanceLease = contracts.every(item => item.contractType === ContractType.FINANCE_LEASE);
        const consentTextTranslation = isFinancing
            ? t('consent-text-financing')
            : isLeasing || isFinanceLease
            ? t('consent-text-leasing')
            : t('consent-text-both');
        return (
            <>
                <Callout title={t('title')} className={'u-mb'}>
                    {t('text')}
                    <ButtonContainer center className={'u-mt'} nav={currentBrand === 'cupra'}>
                        <Button
                            onClick={onButtonClick}
                            type="button"
                            className={currentBrand === 'cupra' ? 'chi-cupra u-bg-base u-text-uppercase' : ''}
                        >
                            {t('button')}
                        </Button>
                    </ButtonContainer>
                </Callout>
                <span
                    className={'u-font-size-fs-2'}
                    dangerouslySetInnerHTML={{
                        __html: t('legal-notice'),
                    }}
                />
                <span
                    className={'u-font-size-fs-2'}
                    dangerouslySetInnerHTML={{
                        __html: consentTextTranslation,
                    }}
                />
                <Modal
                    shown={!!isModalShown}
                    title={t('modal-title')}
                    buttonConfirmText={t('modal-cta')}
                    onConfirm={handleModalConfirm}
                    onClose={onModalClose}
                    testId="chiRedirectModal"
                >
                    {t('modal-subline')}
                </Modal>
            </>
        );
    } else {
        return null;
    }
};
